@if (visible()) {
<div class="fedex-modal-backdrop" (click)="dismiss()"></div>
<div class="fedex-modal-container">
  <div class="fedex-modal-content">
    <div class="fedex-modal-header">
      <h5 class="fw-semibold">FedEx Shipping Options</h5>
      <button type="button" class="btn-close" (click)="dismiss()"></button>
    </div>

    <div class="fedex-modal-body">
      <h4 class="mb-4 alert alert-primary text-black" style="line-height: 2; font-size: 1.15rem;">
        We proudly provide FedEx shipping labels to ensure your documents are delivered securely and
        efficiently to the state office—and returned to you with the same speed and reliability.
      </h4>

      <div class="shipping-inputs mt-3">
        <!-- Option 1: Ship on own -->
        <div class="form-check m-3">
          <input class="form-check-input" type="radio" name="shipType" id="shipMyown"
                 [checked]="shipType() === 'own'"
                 (change)="selectShipType('own')">
          <label class="form-check-label" for="shipMyown">
            I will ship my document(s) using my own shipping account. A return shipping airway bill will be included.
          </label>
        </div>

        <!-- Option 2: Normal mail -->
        <div class="form-check m-3">
          <input class="form-check-input" type="radio" name="shipType" id="shipNormalMail"
                 [checked]="shipType() === 'own'"
                 (change)="selectShipType('own')">
          <label class="form-check-label" for="shipNormalMail">
            I will ship my document(s) using normal mail
          </label>
        </div>

        <!-- Option 3: Use our FedEx -->
        <div class="form-check m-3">
          <input class="form-check-input" type="radio" name="shipType" id="useUs"
                 [checked]="shipType() === 'fedex'"
                 (change)="selectShipType('fedex')">
          <label class="form-check-label" for="useUs">
            I need help purchasing a FedEx airway bill to ship or return my documents.
          </label>
        </div>

        <!-- FedEx Options Panel -->
        @if (openTicketsOptions()) {
        <div class="shipping-type ms-4 pt-1 border border-1 rounded">
          <!-- Alert -->
          @if (shippingAlert()) {
          <div class="alert alert-danger m-3" role="alert">{{ shippingAlert() }}</div>
          }

          <!-- SEND OPTIONS -->
          <div class="fedex-section">
            <div class="form-check m-3">
              <input class="form-check-input" type="checkbox" id="getSend"
                     [checked]="openShippingFromOptions()"
                     (change)="toggleSendOptions()">
              <label class="form-check-label" for="getSend">
                I would like to buy a FedEx airway bill to ship my documents.
              </label>
            </div>

            @if (openShippingFromOptions()) {
            <div class="fedex-type ms-5">
              <div class="form-check m-3">
                <input class="form-check-input" type="radio" name="fedexTypeSend" id="fedex2day"
                       [checked]="fedexTypeSend() === '2dayFrom'"
                       (change)="selectSendType('2dayFrom')">
                <label class="form-check-label" for="fedex2day">
                  2 days delivery (by the end of the day)
                </label>
                @if (sendFullAddress()) {
                <div class="ms-4 text-muted small">
                  Shipping Address: {{ sendFullAddress() }}
                  <a href="#" class="ms-2" (click)="openEditAddressModal('send'); $event.preventDefault()">Change</a>
                </div>
                }
              </div>

              <div class="form-check m-3">
                <input class="form-check-input" type="radio" name="fedexTypeSend" id="fedex1day"
                       [checked]="fedexTypeSend() === '1dayFrom'"
                       (change)="selectSendType('1dayFrom')">
                <label class="form-check-label" for="fedex1day">
                  Priority next day delivery (by 10:30 AM)
                </label>
                @if (sendFullAddress()) {
                <div class="ms-4 text-muted small">
                  Shipping Address: {{ sendFullAddress() }}
                  <a href="#" class="ms-2" (click)="openEditAddressModal('send'); $event.preventDefault()">Change</a>
                </div>
                }
              </div>

              
            </div>
            }
          </div>

          <!-- RECEIVE / RETURN OPTIONS -->
          <div class="ups-section">
            <div class="form-check m-3">
              <input class="form-check-input" type="checkbox" id="getReceive"
                     [checked]="openShippingToOptions()"
                     (change)="toggleReceiveOptions()">
              <label class="form-check-label" for="getReceive">
                I would like to buy a FedEx airway bill to return my documents.
              </label>
            </div>

            @if (openShippingToOptions()) {
            <div class="ups-type ms-5">
              <div class="form-check m-3">
                <input class="form-check-input" type="radio" name="fedexTypeReceive" id="ups2day"
                       [checked]="fedexTypeReceive() === '2dayTo'"
                       (change)="selectReceiveType('2dayTo')">
                <label class="form-check-label" for="ups2day">
                  2 days delivery (by the end of the day)
                </label>
                @if (returnFullAddress()) {
                <div class="ms-4 text-muted small">
                  Shipping Address: {{ returnFullAddress() }}
                  <a href="#" class="ms-2" (click)="openEditAddressModal('return'); $event.preventDefault()">Change</a>
                </div>
                }
              </div>

              <div class="form-check m-3">
                <input class="form-check-input" type="radio" name="fedexTypeReceive" id="ups1day"
                       [checked]="fedexTypeReceive() === '1dayTo'"
                       (change)="selectReceiveType('1dayTo')">
                <label class="form-check-label" for="ups1day">
                  Priority next day delivery (by 10:30 AM)
                </label>
                @if (returnFullAddress()) {
                <div class="ms-4 text-muted small">
                  Shipping Address: {{ returnFullAddress() }}
                  <a href="#" class="ms-2" (click)="openEditAddressModal('return'); $event.preventDefault()">Change</a>
                </div>
                }
              </div>

              <div class="form-check m-3">
                <input class="form-check-input" type="radio" name="fedexTypeReceive" id="fedexIntlReceive"
                       [checked]="fedexTypeReceive() === 'intl'"
                       (change)="selectReceiveType('intl')">
                <label class="form-check-label" for="fedexIntlReceive" style="margin: 0 10px; padding: 0;">
                  An International FedEx airway bill for estimated fee of $65
                </label>
              </div>

              <!-- International Receive Address -->
              @if (showReceiveIntlAddress()) {
              <div class="mt-3 p-3" style="background-color: #f8f9fa; border-radius: 8px;">
                <label class="form-label mb-2">Please type your shipping address:</label>
                <div class="row g-2 mb-2">
                  <div class="col-6">
                    <input type="text" class="form-control mb-2" placeholder="First Name"
                           [(ngModel)]="receiveIntlAddress.firstName">
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control mb-2" placeholder="Last Name"
                           [(ngModel)]="receiveIntlAddress.lastName">
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control mb-2" placeholder="Company Name (optional)"
                           [(ngModel)]="receiveIntlAddress.company">
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control mb-2" placeholder="Street address"
                           [(ngModel)]="receiveIntlAddress.street">
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control mb-2" placeholder="Apt, Floor, Suite, etc. (optional)"
                           [(ngModel)]="receiveIntlAddress.address2">
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control mb-2" placeholder="City"
                           [(ngModel)]="receiveIntlAddress.city">
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control mb-2" placeholder="Province (optional)"
                           [(ngModel)]="receiveIntlAddress.province">
                  </div>
                  <div class="col-4">
                    <input type="text" class="form-control mb-2" placeholder="Country"
                           [(ngModel)]="receiveIntlAddress.country">
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control mb-2" placeholder="Zipcode (optional)"
                           [(ngModel)]="receiveIntlAddress.zipcode">
                  </div>
                  <div class="col-6">
                    <input type="text" class="form-control mb-2" placeholder="Phone"
                           [(ngModel)]="receiveIntlAddress.phone">
                  </div>
                </div>
              </div>
              }
            </div>
            }
          </div>
        </div>
        }
      </div>

      <!-- Submit Button -->
      @if (error()) {
            <div class="alert alert-danger m-3" role="alert">
              {{ error() }}
            </div>
            }

            <div class="modal-footer justify-content-center border-0 pb-4">
              <button type="button" class="btn btn-warning px-5 py-2 fw-bold" (click)="submitShipping()" [disabled]="loading()">
                @if (loading()) {
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  Processing...
                } @else {
                  Save
                }
              </button>
            </div>
    </div>
  </div>

  <!-- Edit Address Sub-Modal -->
  @if (showEditAddressModal()) {
  <div class="edit-address-backdrop" (click)="showEditAddressModal.set(false)"></div>
  <div class="edit-address-modal">
    <div class="modal-content">
      <div class="modal-header bg-light">
        <h5 class="modal-title fw-semibold">Edit Shipping Address</h5>
        <button type="button" class="btn-close" (click)="showEditAddressModal.set(false)"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12 mb-3">
            <label class="form-label">Full Name</label>
            <input type="text" class="form-control" [(ngModel)]="tempAddress.fullName">
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Phone Number</label>
          <input type="text" class="form-control" [(ngModel)]="tempAddress.phone">
        </div>
        <div class="mb-3">
          <label class="form-label">Address</label>
          <input type="text" class="form-control" [(ngModel)]="tempAddress.address">
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">City</label>
            <input type="text" class="form-control" [(ngModel)]="tempAddress.city">
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">State</label>
            <input type="text" class="form-control" [(ngModel)]="tempAddress.state">
          </div>
        </div>
        <div class="mb-3">
          <label class="form-label">Zip Code</label>
          <input type="text" class="form-control" [(ngModel)]="tempAddress.zipcode">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="showEditAddressModal.set(false)">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="saveEditedAddress()">Save Changes</button>
      </div>
    </div>
  </div>
  }
</div>
}
